/**
 * Hardcoded demo configurations
 * Each demo has a splat file, mode (turntable/walkthrough), and display info
 */
// Helper to derive thumbnail from splat file (same name but .webp)
const getThumbnail = (splatFile) => splatFile.replace(/\.(ply|splat|ksplat)$/i, '.webp');

export const DEMOS = [
  {
    id: 'interior-demo',
    name: 'Interior Demo',
    description: 'Verken een fotorealistische interieur ruimte. Loop door de kamer en bekijk elk detail.',
    splatFile: '3DGS/Interior_Demo.ksplat',
    configFile: '3DGS/Interior_Demo.json',
    get thumbnail() { return getThumbnail(this.splatFile); },
    mode: 'walkthrough',
    badge: 'Walkthrough',
    // LOD variants (optional) - loader will use these if available
    lod: {
      high: '3DGS/Interior_Demo.ksplat',      // Full quality
      medium: '3DGS/Interior_Demo_med.ksplat', // 50% gaussians
      low: '3DGS/Interior_Demo_low.ksplat'     // 25% gaussians
    }
  },
  {
    id: 'bike-turntable',
    name: 'Fiets Turntable',
    description: '360° weergave van een fiets. Draai, zoom en bekijk vanuit elke hoek.',
    splatFile: '3DGS/Bike_turntable.ksplat',
    configFile: '3DGS/Bike_turntable.json',
    get thumbnail() { return getThumbnail(this.splatFile); },
    mode: 'turntable',
    badge: 'Turntable',
    lod: {
      high: '3DGS/Bike_turntable.ksplat',
      medium: '3DGS/Bike_turntable_med.ksplat',
      low: '3DGS/Bike_turntable_low.ksplat'
    }
  }
];

/**
 * LOD Quality Levels
 * Used by LODLoader to select appropriate splat file
 */
export const LOD_LEVELS = {
  HIGH: 'high',
  MEDIUM: 'medium', 
  LOW: 'low'
};

/**
 * Get recommended LOD level based on device capabilities
 */
export function getRecommendedLOD() {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const hasLowMemory = navigator.deviceMemory && navigator.deviceMemory < 4;
  const hasSlowConnection = navigator.connection && 
    (navigator.connection.effectiveType === '2g' || navigator.connection.effectiveType === 'slow-2g');
  
  if (isMobile || hasLowMemory || hasSlowConnection) {
    return LOD_LEVELS.LOW;
  }
  
  // Check for high-end device
  const hasHighMemory = navigator.deviceMemory && navigator.deviceMemory >= 8;
  const pixelRatio = window.devicePixelRatio || 1;
  
  if (hasHighMemory && pixelRatio >= 2) {
    return LOD_LEVELS.HIGH;
  }
  
  return LOD_LEVELS.MEDIUM;
}

/**
 * Get splat file URL for given demo and LOD level
 * Falls back to main splatFile if LOD variant doesn't exist
 */
export function getSplatFileForLOD(demo, lodLevel) {
  if (demo.lod && demo.lod[lodLevel]) {
    return demo.lod[lodLevel];
  }
  return demo.splatFile;
}

/**
 * Default config values
 */
export const DEFAULT_CONFIG = {
  camera: {
    position: [0, 2, 5],
    lookAt: [0, 0, 0]
  },
  scene: {
    rotation: [0, 0, 0],
    position: [0, 0, 0],
    scale: 1
  },
  floor: {
    height: 0,
    size: 100
  },
  dome: {
    color: '#1a1a1a',
    enabled: true,
    radius: 50
  },
  mode: 'walkthrough'
};
